import { render, staticRenderFns } from "./ComplaintEditModal.vue?vue&type=template&id=efc8e158&"
import script from "./ComplaintEditModal.vue?vue&type=script&lang=js&"
export * from "./ComplaintEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports